
import {
	getData
} from 'requestModel'
import api from '../api/apiUserInfo'
let cookie_util = require('js-cookie')

export const state = () => ({

})

export const actions = {
	async getUserInfo ({
		commit
	}, params = {}) {
		let uin = cookie_util.get('uin')

		if (!uin) {
			return []
		}

		let ret = await getData({
			api,
			dataset: ['getUserInfo'],
			params: {
				Uin: uin,
				SubAccountUin: uin,
			}
		})

		return ret
	}
}

export const mutations = {
}
